import { ProfileType } from '@/api/backend/types';
import { getLocalizedName } from '@/lib/utils';
import { useAuthStore } from '@/store/auth';
import { Button, RadioGroup, RadioGroupItem } from '@opaz/ui-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface ProfileSelectionProps {
  profiles: ProfileType[];
  onProfileConfirmed: (id: string) => void;
}

export default function ProfileSelection({ profiles, onProfileConfirmed }: ProfileSelectionProps) {
  const { t, i18n } = useTranslation();
  const { activeProfile } = useAuthStore();
  const [selectedProfileId, setSelectedProfileId] = useState<string>(activeProfile?.id || '');

  const handleContinue = async () => {
    if (!selectedProfileId) return;
    onProfileConfirmed(selectedProfileId);
  };

  return (
    <div className="max-w-2xl mx-auto max-h-[500px] overflow-y-auto">
      <RadioGroup size="small" value={selectedProfileId} onValueChange={setSelectedProfileId} dir={i18n.dir()}>
        {profiles.map((profile) => (
          <div key={profile.id} className="flex items-center space-x-3 py-2">
            <RadioGroupItem value={profile.id} id={profile.id} />
            <label htmlFor={profile.id} className="cursor-pointer">
              <div className="flex-1 text-left">
                <div className="font-medium text-foreground">
                  {getLocalizedName(profile.nameEn, profile.nameAr, i18n.language)}
                </div>
                <div className="text-sm text-muted-foreground mt-1">
                  {profile.type === 'COMPANY' ? t('profile.selection.company') : t('profile.selection.investor')} •{' '}
                  {profile.identifier}
                </div>
              </div>
            </label>
          </div>
        ))}
      </RadioGroup>

      <div className="fixed w-full z-50 bottom-0 left-0 bg-wizard-bar border-t border-low">
        <div className="grid grid-flow-col justify-end max-w-[1024px] mx-auto [&>div]:flex-none m-1">
          <Button onClick={handleContinue} disabled={!selectedProfileId}>
            {t('profile.selection.continue')}
          </Button>
        </div>
      </div>
    </div>
  );
}
